import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  loading: false,
  error: null,
  adjustment: {},
  receipts: { error: null, loading: false, data: [] },
  exportStatus: { loading: false, error: null },
}

const adjustmentSlice = createSlice({
  name: "adjustment",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setAdjustment(state, action) {
      state.adjustment = action.payload
    },
    resetState(state) {
      state.data = []
      state.loading = false
      state.error = null
      state.adjustment = {}
      state.receipts = { error: null, loading: false, data: [] }
    },
    // receipts
    setReceiptsLoading(state, action) {
      state.receipts.loading = action.payload
    },
    setReceiptsError(state, action) {
      state.receipts.error = action.payload
    },
    setReceipts(state, action) {
      state.receipts.data = action.payload
    },
    resetReceipts(state) {
      state.receipts = { error: null, loading: false, data: [] }
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
  },
})

export const adjustmentAction = adjustmentSlice.actions

export default adjustmentSlice
